import { AbstractControl } from '@angular/forms';

export function setErrorOnFormControl(
  control: AbstractControl,
  errorId: string,
  errorValue: unknown,
) {
  const currentErrors = control.errors || {};

  if (!errorValue) {
    delete currentErrors[errorId];
  } else {
    currentErrors[errorId] = errorValue;
  }
  if (Object.keys(currentErrors).length === 0) {
    control.setErrors(null);
  } else {
    control.markAsTouched();
    control.setErrors(currentErrors);
  }
}
